/**
 * The pair of bounds that make a date range's two endpoints answer to different constraints: the
 * latest a start may be, and the earliest an end may be. The outer bounds of the range are left to
 * the date picker's own minimum and maximum, so they are deliberately not represented here.
 *
 * Only one of the two applies at a time. Until a start is picked the calendar is offering starts,
 * and afterwards it is offering ends, so the boundary in play is a function of that phase.
 *
 * Both bounds are ISO date strings.
 */
export default class RangeConstraints {

  constructor(maxStartDate, minEndDate) {
    this._maxStartDate = this.#parseIsoDate(maxStartDate)
    this._minEndDate = this.#parseIsoDate(minEndDate)
  }

  isConfigured() {
    return Boolean(this._maxStartDate || this._minEndDate)
  }

  isValidStartDate(date) {
    return date <= this._maxStartDate
  }

  isValidEndDate(date) {
    return date >= this._minEndDate
  }

  validate(selectedDates) {
    const [startDate, endDate] = selectedDates

    if (startDate && !this.isValidStartDate(startDate)) {
      return `invalid start date ${startDate}`
    }

    if (endDate && !this.isValidEndDate(endDate)) {
      return `invalid end date ${endDate}`
    }

    return null
  }

  #parseIsoDate(value) {
    if (!value) {
      return undefined
    }

    const [year, month, day] = value.split('-').map(Number)
    const parsedDate = new Date(year, month - 1, day)

    return Number.isNaN(parsedDate.getTime()) ?
      undefined :
      parsedDate
  }

}
